import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
const accountTypeSlice = createSlice({
  name: "accountType",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const { requestStart, ApiSuccess, requestFailure,  } =
  accountTypeSlice.actions;

const PayOptionsSlice = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(`/private/payoptions`);
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message || "failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default accountTypeSlice.reducer;
